// Rule applied: Use Hotwire (Turbo and Stimulus) for dynamic, SPA-like interactions
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "input"]

  connect() {
    this.updateStars(0)
  }

  select(event) {
    const rating = parseInt(event.currentTarget.dataset.value)
    this.inputTarget.value = rating
    this.updateStars(rating)
  }

  updateStars(rating) {
    this.starTargets.forEach((star, index) => {
      const value = index + 1
      if (value <= rating) {
        star.classList.remove("text-zinc-300", "dark:text-zinc-600")
        star.classList.add("text-yellow-400", "dark:text-yellow-500")
      } else {
        star.classList.remove("text-yellow-400", "dark:text-yellow-500")
        star.classList.add("text-zinc-300", "dark:text-zinc-600")
      }
    })
  }
}
